import { compose } from 'redux';

import { withNoResults } from './helpers';

import BarChartComponent from './BarChart';
import LineChartComponent from './LineChart';
import PieChartComponent from './PieChart';

const BarChart = compose(withNoResults)(BarChartComponent);

const LineChart = compose(withNoResults)(LineChartComponent);

const PieChart = compose(withNoResults)(PieChartComponent);

export { BarChart, LineChart, PieChart };
